 [
{"i":"pi pi-step-backward-alt", "n":"step-backward-alt"},
{"i":"pi pi-compass", "n":"compass"},
{"i":"pi pi-id-card", "n":"id-card"},
{"i":"pi pi-ticket", "n":"ticket"},
{"i":"pi pi-reply", "n":"reply"},
{"i":"pi pi-directions-alt", "n":"forward"},
{"i":"pi pi-directions", "n":"directions"},
{"i":"pi pi-thumbs-up", "n":"thumbs-up"},
{"i":"pi pi-thumbs-down", "n":"thumbs-down"},
{"i":"pi pi-sort-numeric-down-alt", "n":"sort-numeric-down-alt"},
{"i":"pi pi-sort-numeric-up-alt", "n":"sort-numeric-up-alt"},
{"i":"pi pi-sort-numeric-down", "n":"sort-numeric-down"},
{"i":"pi pi-sort-numeric-up", "n":"sort-numeric-up"},
{"i":"pi pi-sort-alpha-down", "n":"sort-alpha-down"},
{"i":"pi pi-sort-alpha-up", "n":"sort-alpha-up"},
{"i":"pi pi-sort-alt", "n":"sort-alt"},
{"i":"pi pi-sort-amount-up", "n":"sort-amount-up"},
{"i":"pi pi-sort-amount-down", "n":"sort-amount-down"},
{"i":"pi pi-sort-amount-down-alt", "n":"sort-amount-down-alt"},
{"i":"pi pi-sort-amount-up-alt", "n":"sort-amount-up-alt"},
{"i":"pi pi-palette", "n":"palette"},
{"i":"pi pi-undo", "n":"id-card"},
{"i":"pi pi-desktop", "n":"desktop"},
{"i":"pi pi-sliders-v", "n":"sliders-v"},
{"i":"pi pi-sliders-h", "n":"sliders-h"},
{"i":"pi pi-search-plus", "n":"search-plus"},
{"i":"pi pi-search-minus", "n":"search-minus"},
{"i":"pi pi-check-square", "n":"check-square"},
{"i":"pi pi-chart-line", "n":"chart-line"},
{"i":"pi pi-user-edit", "n":"user-edit"},
{"i":"pi pi-exclamation-circle", "n":"exclamation-circle"},
{"i":"pi pi-android", "n":"android"},
{"i":"pi pi-google", "n":"google"},
{"i":"pi pi-apple", "n":"apple"},
{"i":"pi pi-microsoft", "n":"microsoft"},
{"i":"pi pi-heart", "n":"heart"},
{"i":"pi pi-mobile", "n":"mobile"},
{"i":"pi pi-tablet", "n":"tablet"},
{"i":"pi pi-key", "n":"key"},
{"i":"pi pi-shopping-cart", "n":"shopping-cart"},
{"i":"pi pi-comments", "n":"comments"},
{"i":"pi pi-comment", "n":"comment"},
{"i":"pi pi-briefcase", "n":"briefcase"},
{"i":"pi pi-bell", "n":"bell"},
{"i":"pi pi-paperclip", "n":"paperclip"},
{"i":"pi pi-share-alt", "n":"share-alt"},
{"i":"pi pi-envelope", "n":"envelope"},
{"i":"pi pi-money-bill", "n":"money-bill"},
{"i":"pi pi-images", "n":"images"},
{"i":"pi pi-sign-in", "n":"sign-in"},
{"i":"pi pi-sign-out", "n":"sign-out"},
{"i":"pi pi-wifi", "n":"wifi"},
{"i":"pi pi-sitemap", "n":"forward"},
{"i":"pi pi-chart-bar", "n":"chart-bar"},
{"i":"pi pi-camera", "n":"camera"},
{"i":"pi pi-dollar", "n":"dollar"},
{"i":"pi pi-lock-open", "n":"lock-open"},
{"i":"pi pi-table", "n":"table"},
{"i":"pi pi-map-marker", "n":"map-marker"},
{"i":"pi pi-list", "n":"list"},
{"i":"pi pi-eye-slash", "n":"eye-slash"},
{"i":"pi pi-eye", "n":"eye"},
{"i":"pi pi-folder-open", "n":"folder-open"},
{"i":"pi pi-folder", "n":"folder"},
{"i":"pi pi-inbox", "n":"inbox"},
{"i":"pi pi-lock", "n":"lock"},
{"i":"pi pi-unlock", "n":"unlock"},
{"i":"pi pi-tags", "n":"tags"},
{"i":"pi pi-tag", "n":"tag"},
{"i":"pi pi-power-off", "n":"power-off"},
{"i":"pi pi-save", "n":"save"},
{"i":"pi pi-question-circle", "n":"question-circle"},
{"i":"pi pi-question", "n":"question"},
{"i":"pi pi-clone", "n":"clone"},
{"i":"pi pi-calendar-times", "n":"calendar-times"},
{"i":"pi pi-calendar-minus", "n":"calendar-minus"},
{"i":"pi pi-calendar-plus", "n":"calendar-plus"},
{"i":"pi pi-ellipsis-v", "n":"ellipsis-v"},
{"i":"pi pi-ellipsis-h", "n":"ellipsis-h"},
{"i":"pi pi-bookmark", "n":"bookmark"},
{"i":"pi pi-globe", "n":"globe"},
{"i":"pi pi-filter", "n":"filter"},
{"i":"pi pi-print", "n":"print"},
{"i":"pi pi-align-right", "n":"align-right"},
{"i":"pi pi-align-left", "n":"align-left"},
{"i":"pi pi-align-center", "n":"align-center"},
{"i":"pi pi-align-justify", "n":"align-justify"},
{"i":"pi pi-cog", "n":"cog"},
{"i":"pi pi-cloud-download", "n":"cloud-download"},
{"i":"pi pi-cloud-upload", "n":"cloud-upload"},
{"i":"pi pi-cloud", "n":"cloud"},
{"i":"pi pi-pencil", "n":"pencil"},
{"i":"pi pi-users", "n":"users"},
{"i":"pi pi-clock", "n":"clock"},
{"i":"pi pi-user-minus", "n":"user-minus"},
{"i":"pi pi-user-plus", "n":"user-plus"},
{"i":"pi pi-trash", "n":"trash"},
{"i":"pi pi-window-minimize", "n":"window-minimize"},
{"i":"pi pi-window-maximize", "n":"window-maximize"},
{"i":"pi pi-external-link", "n":"external-link"},
{"i":"pi pi-refresh", "n":"refresh"},
{"i":"pi pi-user", "n":"user"},
{"i":"pi pi-exclamation-triangle", "n":"exclamation-triangle"},
{"i":"pi pi-calendar", "n":"calendar"},
{"i":"pi pi-chevron-circle-left", "n":"chevron-circle-left"},
{"i":"pi pi-chevron-circle-down", "n":"chevron-circle-down"},
{"i":"pi pi-chevron-circle-right", "n":"chevron-circle-right"},
{"i":"pi pi-chevron-circle-up", "n":"chevron-circle-up"},
{"i":"pi pi-angle-double-down", "n":"angle-double-down"},
{"i":"pi pi-angle-double-left", "n":"angle-double-left"},
{"i":"pi pi-angle-double-right", "n":"angle-double-right"},
{"i":"pi pi-angle-double-up", "n":"angle-double-up"},
{"i":"pi pi-angle-down", "n":"angle-down"},
{"i":"pi pi-angle-left", "n":"angle-left"},
{"i":"pi pi-angle-right", "n":"angle-right"},
{"i":"pi pi-angle-up", "n":"angle-up"},
{"i":"pi pi-upload", "n":"upload"},
{"i":"pi pi-download", "n":"download"},
{"i":"pi pi-ban", "n":"ban"},
{"i":"pi pi-star-o", "n":"star-o"},
{"i":"pi pi-star", "n":"star"},
{"i":"pi pi-chevron-left", "n":"chevron-left"},
{"i":"pi pi-chevron-right", "n":"chevron-right"},
{"i":"pi pi-chevron-down", "n":"chevron-down"},
{"i":"pi pi-chevron-up", "n":"chevron-up"},
{"i":"pi pi-caret-left", "n":"caret-left"},
{"i":"pi pi-caret-right", "n":"caret-right"},
{"i":"pi pi-caret-down", "n":"caret-down"},
{"i":"pi pi-caret-up", "n":"caret-up"},
{"i":"pi pi-search", "n":"search"},
{"i":"pi pi-check", "n":"check"},
{"i":"pi pi-check-circle", "n":"check-circle"},
{"i":"pi pi-times", "n":"times"},
{"i":"pi pi-times-circle", "n":"times-circle"},
{"i":"pi pi-plus", "n":"plus"},
{"i":"pi pi-plus-circle", "n":"plus-circle"},
{"i":"pi pi-minus", "n":"minus"},
{"i":"pi pi-minus-circle", "n":"minus-circle"},
{"i":"pi pi-circle-on", "n":"circle-on"},
{"i":"pi pi-circle-off", "n":"circle-off"},
{"i":"pi pi-sort-down", "n":"sort-down"},
{"i":"pi pi-sort-up", "n":"sort-up"},
{"i":"pi pi-sort", "n":"sort"},
{"i":"pi pi-step-backward", "n":"step-backward"},
{"i":"pi pi-step-forward", "n":"step-forward"},
{"i":"pi pi-th-large", "n":"th-large"},
{"i":"pi pi-arrow-down", "n":"arrow-down"},
{"i":"pi pi-arrow-left", "n":"arrow-left"},
{"i":"pi pi-arrow-right", "n":"arrow-right"},
{"i":"pi pi-arrow-up", "n":"arrow-up"},
{"i":"pi pi-bars", "n":"bars"},
{"i":"pi pi-arrow-circle-down", "n":"arrow-circle-down"},
{"i":"pi pi-arrow-circle-left", "n":"arrow-circle-left"},
{"i":"pi pi-arrow-circle-right", "n":"arrow-circle-right"},
{"i":"pi pi-arrow-circle-up", "n":"arrow-circle-up"},
{"i":"pi pi-info", "n":"info"},
{"i":"pi pi-info-circle", "n":"info-circle"},
{"i":"pi pi-home", "n":"home"},
{"i":"pi pi-spinner", "n":"spinner"},
{"i":"pi pi-file", "n":"file"},
{"i":"pi pi-file-excel", "n":"file-excel"},
{"i":"pi pi-file-pdf", "n":"file-pdf"},
{"i":"pi pi-file-o", "n":"file-o"},
{"i":"pi pi-step-backward-alt", "n":"step-backward-alt"},
{"i":"pi pi-step-forward-alt", "n":"step-forward-alt"},
{"i":"pi pi-forward", "n":"forward"},
{"i":"pi pi-backward", "n":"backward"},
{"i":"pi pi-fast-backward", "n":"fast-backward"},
{"i":"pi pi-fast-forward", "n":"fast-forward"},
{"i":"pi pi-pause", "n":"pause"},
{"i":"pi pi-play", "n":"play"},
{"i":"pi pi-eject", "n":"eject"},
{"i":"fa-solid fa-signature", "n":"signature"},
{"i":"fa-solid fa-clipboard-check", "n":"clipboard-check"},
{"i":"fa-solid fa-stairs", "n":"stairs"},
{"i":"fa-solid fa-hand-holding-dollar", "n":"hand-holding-dollar"},
{"i":"fa-solid fa-business-time", "n":"business-time"},
{"i":"fa-solid fa-gears", "n":"gears"},
{"i":"fa-solid fa-users-viewfinder", "n":"users-viewfinder"}
]